import React from 'react';
import { useSearchState } from '@hotelplan/fdr.lib.search.with-state';
import CurrentSearch from 'components/domain/currentSearch/CurrentSearch';
import CurrentSearchSkeleton from 'components/domain/currentSearch/CurrentSearch.skeleton';
import {
  CurrentSearchFieldTypes,
  useFdrCurrentSearch,
} from 'fdr/components/candidate/fdr-search-control/use-fdr-current-search';
import { IWishlistState } from 'fdr/components/local/fdr-wishlist/fdr-wishlist.types';

const WishlistSearchControlFormCurrentSearchField: React.FC<{
  handleEdit: () => void;
  fieldTypes?: CurrentSearchFieldTypes[];
}> = ({ fieldTypes, handleEdit }) => {
  const {
    loading,
    state: { searchControl },
  } = useSearchState<IWishlistState>();

  const currentSearchItems = useFdrCurrentSearch(searchControl, fieldTypes);

  if (loading || !searchControl) return <CurrentSearchSkeleton />;

  return <CurrentSearch items={currentSearchItems} handleEdit={handleEdit} />;
};

export default WishlistSearchControlFormCurrentSearchField;
